
import { formatDate } from "@/javascript/formatDate"
import goBack from '@/components/public-components/goBack/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import bus from '@/javascript/bus'
import util from '@/javascript/util'

export default {
components: {
Toast,
goBack
},
data () {
return {
minHeight: 0,
userInfo: bus.userInfo,
complaints: {},
toast: {
text: '',
show: false
},
infiniteStatus: false,
infiniteAll: false,
listPageNo: 0,
listPageSize: 10,
}
},
created () {
this.getComplaintList()
},
mounted () {
this.minHeight = document.documentElement.clientHeight
window.addEventListener('scroll', this.windowScroll)

document.title = this.PAGE_TITLE + '我的投诉'
},
methods: {
windowScroll: function () {
if (util.pullUpLoad()) {
this.infinite()
}
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (!this.$refs.stickyBox) {
return
}
if (scrollTop >= this.$refs.stickyBox.offsetTop) {
this.districtSticky = true
this.handleMinHeight = document.documentElement.clientHeight - this.$refs.stickyBox.offsetTop + this.$refs.stickyBox.offsetTop
if (document.documentElement.clientWidth > 640) {
this.handleRight = (document.documentElement.clientWidth - 640) / 2
}
} else {
this.districtSticky = false
this.handleMinHeight = document.documentElement.clientHeight - this.$refs.stickyBox.offsetTop + scrollTop
this.handleRight = 0
}
},
getComplaintList () {
const param = {
page: this.listPageNo,
size: this.listPageSize,
token: bus.userInfo.access_token,
deptCode: this.DEPT_CODE.DEPTCODE,
userId: bus.userInfo.user.id
}
this.$http.get('/api/wtcp-complaints/public/complaints/page?access_token=' + param.token + "&userId=" + param.userId + "&deptCode=" + param.deptCode  + "&page=" + param.page + "&size=" + param.size).then((response) => {
const resData = response.data.data.content

resData.forEach(item => {
let state = ''
switch (item.status) {
case 0: state = '待受理'
break;
case 1: state = '处理中'
break;
case 2: state = '已处理'
break;
case 3: state = '不予受理'
break;
case 4: state = '已撤回'
break;
}
const date = formatDate(item.createdDate, 'MM月dd日'),
timeTemp = item.updatedDate ? item.updatedDate : item.createdDate,
time = formatDate(timeTemp, 'MM月dd日 hh:mm'),
tip = '该投诉' + (item.status === 0 ? '已提交' : state)
if (!this.complaints.hasOwnProperty(date)) {
this.$set(this.complaints, date, [])
}
this.complaints[date].push({
id: item.id,
address: item.areaName,
title: item.principalName,
desc: item.reasons,
tip: time + '&nbsp;&nbsp;&nbsp;&nbsp;' + tip,
state: state,
status: item.status
})
})
if (resData.length < this.listPageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
})
},
recallComplaint (key, index, id) {
this.$http.get('/api/wtcp-complaints/public/complaints/rollback/' + id + '?access_token=' + bus.userInfo.access_token).then((response) => {
if (response.data.status === 1) {
const now = new Date()
this.complaints[key][index].status = 4
this.complaints[key][index].state = '已撤回'
this.complaints[key][index].tip = formatDate(now.getMonth()+1 + '-' + now.getDate() + ' ' +  now.getHours() + ':' + now.getMinutes(), 'MM月dd日 hh:mm') + '&nbsp;&nbsp;&nbsp;&nbsp;' + '该投诉已撤回'
this.toast.text = response.data.msg
this.toast.show = true
}
})
},
toComplaintDetails (id) {
this.$router.push({path: '/complaintDetails/' + id})
},
infinite: function () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}

this.infiniteStatus = true
this.listPageNo += this.listPageSize
this.getComplaintList()
},
}
}
